import { all, takeEvery, call, put } from "redux-saga/effects";
import * as actionTypes from "../constants/actionTypes";
import * as actions from '../actions'
import axios from '../services';
import { sessionExpiredMsg } from "../constants/constants";

function* getHostProfileData(action) {
    try {
        const { contestName, judgeId } = action.payload;
        let user;
        if (judgeId == undefined) {
            user = JSON.parse(localStorage.getItem('userData'))._id
        } else {
            user = judgeId;
        }

        let response = yield axios.get(`/users/host-profile/${contestName}?userId=${user}`).then(response => response).catch(err => console.log(err))
            .then(async response => response)
            .catch(async error => {
                return error;
            });
        let mediaResponse = yield axios.get(`/users/host-media/${contestName}/get-all-media/${user}?limit=20`).then(response => response).catch(err => console.log(err))
            .then(async response => response)
            .catch(async error => {
                return error;
            });
        let endorseUserResponse = yield axios.get(`/users/host-evalute/${contestName}/get-endorse-user?userId=${user}`).then(response => response).catch(err => console.log(err))
            .then(async response => response)
            .catch(async error => {
                return error;
            });
        if (response.status !== 200) {
            yield put(actions.hideAppLoader());
            yield put(actions.modalOpen({ message: response.response.data.msg }));
        }
        let Media;
        if (mediaResponse.status == 200) {
            Media = mediaResponse.data.data;
            for (let index = 0; index < Media.length; index++) {
                if (Media[index].mediaType != 'image') {
                    let status = yield fetch(`https://cdn.jwplayer.com/v2/media/${Media[index].url}/poster.jpg?width=480`);
                    Media[index].imageStatus = status.status == 200;
                }
            }
        } else if (mediaResponse == "Error: Request failed with status code 401") {
            yield put(actions.hideAppLoader());
            put(actions.modalOpen({ message: sessionExpiredMsg, redirectURL: `/logout` }));
        } else {
            yield put(actions.hideAppLoader());
            yield put(actions.modalOpen({ message: mediaResponse.data.msg }));
        }

        if (endorseUserResponse.status == 200) { 
            response.data.data.endorseUser = endorseUserResponse.data.data; 
        } else if (endorseUserResponse == "Error: Request failed with status code 401") {
            yield put(actions.hideAppLoader());
            put(actions.modalOpen({ message: sessionExpiredMsg, redirectURL: `/logout` }));
        } else {
            yield put(actions.hideAppLoader());
            yield put(actions.modalOpen({ message: endorseUserResponse.response.data.msg }));
        }



        if (response.status === 200 && mediaResponse.status === 200) {
            yield put(actions.getHostProfileDataSuccess({ hostProfileData: response.data.data, Media }));
        } else {
            yield put(actions.hideAppLoader());
            yield put(actions.modalOpen({ message: response.response.data.msg }));
        }
    } catch (error) {
        console.log("ERROR FROM SAGA HOST PROFILE", error.message);
    }
}

function* getHostProfileMedia(action) {
    try {
        const { contestName, judgeId, hostProfileMediaLength } = action.payload;
        let user;
        if (judgeId == undefined) {
            user = JSON.parse(localStorage.getItem('userData'))._id
        } else {
            user = judgeId;
        }
        let mediaResponse = yield axios.get(`/users/host-media/${contestName}/get-all-media/${user}?skip=${hostProfileMediaLength}&limit=20`).then(response => response).catch(err => console.log(err))
            .then(async response => response)
            .catch(async error => {
                return error;
            });


        if (mediaResponse.status === 200) {
            let Media = mediaResponse.data.data;
            for (let index = 0; index < Media.length; index++) {
                if (Media[index].mediaType != 'image') {
                    let status = yield fetch(`https://cdn.jwplayer.com/v2/media/${Media[index].url}/poster.jpg?width=480`);
                    Media[index].imageStatus = status.status == 200;
                }
            }
            yield put(actions.getHostProfileMediaSuccess(Media));
        } else if (mediaResponse == "Error: Request failed with status code 401") {
            yield put(actions.hideAppLoader());
            put(actions.modalOpen({ message: sessionExpiredMsg, redirectURL: `/logout` }));
        } else {
            yield put(actions.hideAppLoader());
            yield put(actions.modalOpen({ message: mediaResponse.response.data.msg }));
        }
    } catch (error) {
        console.log("ERROR FROM SAGA HOST PROFILE", error.message);
    }
}

function* uploadContestData(action) {
    try {
        const { arrContestName } = action.payload;
        let response = yield axios.post(`/users/contest/${encodeURIComponent(arrContestName[0])}/host-media`, action.payload)
            .then(async response => response)
            .catch(async error => {
                return error;
            });
        if (response.status == 200) {
            yield put(actions.hideAppLoader());
            yield put(actions.modalOpen({ message: response.data.msg, notifyType: 2 }));
        } else if (response == "Error: Request failed with status code 401") {
            yield put(actions.hideAppLoader());
            put(actions.modalOpen({ message: sessionExpiredMsg, redirectURL: `/logout` }));
        } else {
            yield put(actions.hideAppLoader());
            yield put(actions.modalOpen({ message: response.response.data.msg }));
        }
    } catch (error) {
        yield put(actions.hideAppLoader());
        console.log("ERROR FROM SAGA HOST PROFILE", error.message);
    }


}

export default function* rootsaga() {
    yield takeEvery(actionTypes.GET_HOST_PROFILE_DATA, getHostProfileData);
    yield takeEvery(actionTypes.GET_HOST_PROFILE_MEDIA, getHostProfileMedia);
    yield takeEvery(actionTypes.UPLOAD_HOST_CONTEST_DATA, uploadContestData);
}